/* Cappafe components authored for Dawn; no paid-theme runtime dependency. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  class CappafeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.cf-track');
      this.paused = reduced.matches;
      this.abort = new AbortController();
      const on = (el, event, handler) => el?.addEventListener(event, handler, {signal: this.abort.signal});
      const parent = this.parentElement;
      on(parent.querySelector('[data-prev]'), 'click', () => this.step(-1));
      on(parent.querySelector('[data-next]'), 'click', () => this.step(1));
      on(this, 'mouseenter', () => this.hovered = true);
      on(this, 'mouseleave', () => this.hovered = false);
      on(this, 'focusin', () => this.focused = true);
      on(this, 'focusout', () => this.focused = false);
      const pause = this.querySelector('.cf-autoplay');
      const enabled = this.dataset.autoplay === 'true' && this.track.children.length > 1;
      pause.hidden = !enabled;
      on(pause, 'click', () => {
        this.paused = !this.paused;
        pause.setAttribute('aria-pressed', String(this.paused));
        pause.textContent = this.paused ? '▶ Otomatik kaydırmayı başlat' : 'Ⅱ Otomatik kaydırmayı durdur';
      });
      if (enabled) this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !this.focused && !document.hidden && this.getClientRects().length && !reduced.matches) this.step(1);
      }, 5000);
    }
    step(direction) {
      const t = this.track;
      const amount = (t.firstElementChild?.getBoundingClientRect().width || 300) + parseFloat(getComputedStyle(t).gap || 16);
      const end = t.scrollWidth - t.clientWidth;
      if (end < 3) return;
      let next = t.scrollLeft + amount * direction;
      if (direction > 0 && t.scrollLeft >= end - 3) next = 0;
      else if (direction < 0 && t.scrollLeft <= 3) next = end;
      t.scrollTo({left: next, behavior: reduced.matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.ready = false; }
  }
  customElements.define('cf-carousel', CappafeCarousel);
  class CappafeFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.make = this.querySelector('[data-make]');
      this.model = this.querySelector('select[data-model]');
      this.year = this.querySelector('select[data-year]');
      this.status = this.querySelector('[role=status]');
      this.make.addEventListener('change', () => this.load(false));
      this.model.addEventListener('change', () => this.load(true));
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.make.value) return this.make.reportValidity();
        const url = new URL(this.year.value || this.model.value || this.make.value, location.origin);
        url.searchParams.delete('section_id');
        location.assign(url.pathname + url.search);
      });
    }
    reset(select, text) { select.replaceChildren(new Option(text, '')); select.disabled = true; }
    async load(modelSelected) {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reset(this.year, this.dataset.year);
      if (!modelSelected) this.reset(this.model, this.dataset.model);
      const base = modelSelected ? this.model.value : this.make.value;
      if (!base) return;
      this.status.textContent = 'Seçenekler yükleniyor…';
      try {
        const url = new URL(base, location.origin);
        url.searchParams.set('section_id', 'cf-vehicle-data');
        const response = await fetch(url, {signal});
        if (!response.ok) throw new Error('filters');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const filters = JSON.parse(doc.querySelector('[data-cf-filter-data]')?.textContent || '[]');
        const target = modelSelected ? this.year : this.model;
        const filter = filters.find(f => modelSelected ? /year|yıl|yil/i.test(f.param + ' ' + f.label) : /model/i.test(f.param + ' ' + f.label));
        const values = filter?.values.filter(v => v.count > 0) || [];
        values.forEach(v => target.add(new Option(v.label, v.url)));
        target.disabled = !values.length;
        this.status.textContent = values.length ? '' : 'Bu seçim için ek filtre yok. Mevcut ürünleri görüntüleyebilirsiniz.';
      } catch (error) {
        if (error.name !== 'AbortError') this.status.textContent = 'Filtreler yüklenemedi. Markanın ürünlerini görüntüleyebilirsiniz.';
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('cf-finder', CappafeFinder);
  function init(root = document) {
    root.querySelectorAll('.cf-search').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', () => {
        const type = form.querySelector('[data-search-type]')?.value;
        const query = form.querySelector('[name=q]');
        if (type && query) query.value = `product_type:"${type.replace(/["\\]/g,'')}" ${query.value}`;
      });
    });
    root.querySelectorAll('.cf-nav-item').forEach(item => {
      if (item.dataset.bound) return;
      item.dataset.bound = 'true';
      item.addEventListener('mouseenter', () => {
        if (!matchMedia('(hover:hover) and (min-width:750px)').matches) return;
        document.querySelectorAll('.cf-nav-item').forEach(other => { if (other !== item) other.open = false; });
        item.open = true;
      });
      item.addEventListener('mouseleave', () => {
        if (matchMedia('(hover:hover) and (min-width:750px)').matches && !item.contains(document.activeElement)) item.open = false;
      });
      item.querySelector('summary').addEventListener('click', () => document.querySelectorAll('.cf-nav-item').forEach(other => { if (other !== item) other.open = false; }));
      item.addEventListener('keydown', event => { if (event.key === 'Escape') {item.open = false; item.querySelector('summary').focus();} });
    });
    root.querySelectorAll('.cf-products').forEach(group => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      const tabs = [...group.querySelectorAll('[role=tab]')];
      const activate = tab => {
        tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; document.getElementById(t.getAttribute('aria-controls')).hidden = !selected; });
      };
      tabs.forEach((tab, i) => {
        tab.tabIndex = i ? -1 : 0;
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', e => { if (['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) { e.preventDefault();const index = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length-1 : (i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;activate(tabs[index]);tabs[index].focus(); } });
      });
    });
    root.querySelectorAll('.cf-story-item').forEach(item => {
      if (item.dataset.bound) return;
      item.dataset.bound = 'true';
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        const group = item.closest('.cf-story');
        group.querySelectorAll('.cf-story-item').forEach(other => { if (other !== item) other.open = false; });
        const content = item.querySelector('template');
        if (content) group.querySelector('.cf-story-image').replaceChildren(content.content.cloneNode(true));
      });
    });
    root.querySelectorAll('.cf-compat').forEach(group => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      let rows;
      try {rows = JSON.parse(group.querySelector('[data-compat-rows]').textContent);} catch { return; }
      let all = false;
      const search = group.querySelector('[data-compat-search]'), more = group.querySelector('[data-compat-more]');
      const render = () => {
        const words = search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
        const filtered = rows.filter(row => words.every(w => row.join(' ').toLocaleLowerCase().includes(w)));
        const shown = all || words.length ? filtered : filtered.slice(0,25);
        const fragment = document.createDocumentFragment();
        shown.forEach(row => {const tr = document.createElement('tr');row.forEach(value => {const td=document.createElement('td');td.textContent=value ?? '';tr.append(td);});fragment.append(tr);});
        group.querySelector('tbody').replaceChildren(fragment);
        group.querySelector('[data-compat-count]').textContent = `${shown.length} / ${filtered.length}`;
        more.hidden = all || words.length > 0 || filtered.length <= 25;
      };
      search.addEventListener('input',render);more.addEventListener('click',()=>{all=true;render();});render();
    });
  }
  init();
  const support = document.querySelector('.cf-help-dialog');
  document.querySelector('[data-cf-help-open]')?.addEventListener('click', () => support.showModal());
  document.querySelector('[data-cf-help-close]')?.addEventListener('click', () => support.close());
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('click', e => { if (!e.target.closest('.cf-nav-item')) document.querySelectorAll('.cf-nav-item[open]').forEach(d => d.open = false); });
})();

/* Mobil hamburger çekmece (Claude 17.09) */
(() => {
  const setOpen = open => {
    const header = document.querySelector('.cf-header');
    if (!header) return;
    header.classList.toggle('cf-nav-open', open);
    document.body.classList.toggle('cf-nav-lock', open);
    const toggle = header.querySelector('.cf-menu-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    const backdrop = header.querySelector('.cf-nav-backdrop');
    if (backdrop) backdrop.hidden = !open;
    if (open) header.querySelector('.cf-drawer-head button')?.focus();
    else if (toggle && header.contains(document.activeElement)) toggle.focus();
  };
  document.addEventListener('click', e => {
    if (e.target.closest('.cf-menu-toggle')) { e.preventDefault(); setOpen(true); }
    else if (e.target.closest('[data-cf-nav-close]')) { e.preventDefault(); setOpen(false); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && document.querySelector('.cf-nav-open')) setOpen(false); });
  matchMedia('(min-width:750px)').addEventListener('change', m => { if (m.matches) setOpen(false); });
})();
